import Input from './Input.jsx';
import { MP_PROVINCES, getCitiesForProvince } from '../constants/mpLocations.js';

/**
 * Campos de ubicación reutilizables para formularios de sucursal.
 * Maneja el select de provincia y el select/input dinámico de ciudad.
 *
 * Props:
 *   form       - objeto con los campos (streetName, streetNumber, zipCode, cityName, stateName, countryId, latitude, longitude)
 *   onChange   - fn(field, value) para actualizar el form
 *   showCountry - mostrar campo país (default true)
 */
export default function LocationFields({ form, onChange, showCountry = true }) {
  const cities = getCitiesForProvince(form.stateName);

  const handleProvinceChange = (e) => {
    onChange('stateName', e.target.value);
    onChange('cityName', ''); // resetear ciudad al cambiar provincia
  };

  return (
    <div className="grid grid-cols-2 gap-3">
      <Input label="Calle *" value={form.streetName || ''} onChange={e => onChange('streetName', e.target.value)} />
      <Input label="Número" value={form.streetNumber || ''} onChange={e => onChange('streetNumber', e.target.value)} />
      <Input label="CP" value={form.zipCode || ''} onChange={e => onChange('zipCode', e.target.value)} />

      {/* Provincia */}
      <div>
        <label className="label">Provincia *</label>
        <select className="input-base" value={form.stateName || ''} onChange={handleProvinceChange}>
          <option value="">Seleccioná una provincia</option>
          {MP_PROVINCES.map(p => <option key={p} value={p}>{p}</option>)}
        </select>
      </div>

      {/* Ciudad — dropdown si hay lista, texto libre si no */}
      <div>
        <label className="label">Ciudad *</label>
        {cities ? (
          <>
            <select className="input-base" value={form.cityName || ''} onChange={e => onChange('cityName', e.target.value)}>
              <option value="">Seleccioná una ciudad / barrio</option>
              {cities.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
            {!form.cityName && form.stateName && (
              <p className="text-xs text-amber-400 mt-1">
                ⚠ Seleccioná el {form.stateName === 'Capital Federal' ? 'barrio' : 'partido / ciudad'} para poder sincronizar con MP
              </p>
            )}
          </>
        ) : (
          <input
            className="input-base"
            value={form.cityName || ''}
            onChange={e => onChange('cityName', e.target.value)}
            placeholder="Nombre de la ciudad"
          />
        )}
      </div>

      {showCountry && (
        <Input label="País" value={form.countryId || 'AR'} onChange={e => onChange('countryId', e.target.value)} />
      )}

      <Input label="Latitud *" type="number" value={form.latitude || ''} onChange={e => onChange('latitude', e.target.value)} placeholder="-34.6037" />
      <Input label="Longitud *" type="number" value={form.longitude || ''} onChange={e => onChange('longitude', e.target.value)} placeholder="-58.3816" />
    </div>
  );
}
